export default {
  proceed: "Proceed",
  ok: "OK",
  product: "Product",
  dispute: "Dispute",
  payment: "Payment",
  paymentPlans: "Payment Plans",
  thisIsNotMyDebt: "This is not my debt.",
  amountIsWrong: "The amount is wrong.",
  other: "Other",
  disputeSuccess: "Dispute filed successfully",
  choosePlan: "Choose Plan",
  Installments: "Installments",
  oneTime: "One-Time",
  paymentSuccess: "Payment Success",
  calendarReminders: "Calendar reminders",
  checkout: "Checkout",
  creditCard: "Credit",
  debitCard: "Debit",
  achPayment: "ACH Payment",
  ach: "ACH",
  debit: "Debit",
  card: "Card",
  contactSupport: "Contact support",
  paymentTermsAndConditions:
    "By checking this box, I agree to the {termsAndConditions} and authorize Bounce AI to debit my account according to my plan and email me confirmations, reminders, and receipts. I understand I can update my preferences or withdraw this authorization at any time.",
  shortPaymentTermsAndConditions:
    "I accept the {termsAndConditions} and authorize {collectionLabel} to electronically debit my designated account as described above.",
  singlePaymentTermsAndConditions:
    "By checking this box, you confirm that you have read and agree to the {termsAndConditions} and authorize {collectionLabel} to electronically debit your designated account as described above.",
  payments: "Payments",
  starting: "Starting",
  ending: "Ending",
  unknown: "Unknown",
  details: "Details",
  account: "Account",
  roles: "Roles",
  dashboard: "Dashboard",
  email: "Email",
  password: "Password",
  fullName: "Full Name",
  cancel: "Cancel",
  continue: "Continue",
  notAvailable: "N/A",
  remove: "Remove",
  actions: "Actions",
  preview: "Preview",
  download: "Download",
  result: "Result",
  id: "ID",
  send: "Send",
  close: "Close",
  submit: "Submit",
  open: "Open",
  create: "Create",
  delete: "Delete",
  archive: "Archive",
  share: "Share",
  update: "Update",
  custom: "Custom",
  Custom: "Custom",
  reason: "Reason",
  import: "Import",
  search: "Search",
  select: "Select",
  next: "Next",
  back: "Back",
  admin: "Admin",
  generate: "Generate",
  invalidFieldUpload: "Cannot upload selected file.",
  invalidFieldUploadTooLarge: "Cannot upload selected file. File size too large.",
  invalidFieldUploadTooSmall: "Cannot upload selected file. File size too small.",
  invalidFieldUploadTooManyFiles: "Cannot upload selected file. Too many files selected.",
  invalidFieldUploadInvalidType: "Cannot upload selected file. Invalid file type.",
  status: "Status",
  description: "Description",
  name: "Name",
  installment: "installment",
  regarding: "Regarding",
  installmentAmount: "Installment Amount",
  amount: "Amount",
  paymentSchedule: "Payment Schedule",
  paymentNumber: "Payment No.",
  updatedAt: "Updated At",
  dueDate: "Due Date",
  dueOn: "due on",
  paidOn: "Paid on {date}",
  paymentInProgress: "Payment in progress",
  scheduledPayment: "Scheduled Payment",
  paid: "Paid",
  late: "Late",
  payNextPayment: "Pay Next Payment",
  payNow: "Pay now",
  resolveNow: "Resolve now",
  updatePayment: "Update payment",
  confirmAndContribute: "Confirm and contribute",
  resolveLatePayment: "Resolve late payment",
  ourTemporaryRelief: "Our 3-month Temporary Relief Program is here to help.",
  notOnlyWillYouBenefit:
    "Not only will you benefit from smaller, more manageable payments, but you’ll also avoid negative reports on your credit.",
  talkToOneOfOurExpertsToday: "Talk to one of our experts today to see if you’re eligible.",
  saveChanges: "Save changes",
  activateAutoPay: "Activate AutoPay",
  makePayment: "Make a Payment",
  success: "Success!",
  yourOpinionMatters: "Your opinion matters",
  haveAMinuteToSpare: "Have a minute to spare? We’d love if you left a quick review at {link}",
  enumBankAccountTypeUnknown: "Unknown",
  enumBankAccountTypePersonalChecking: "Personal Checking",
  enumBankAccountTypePersonalSavings: "Personal Savings",
  enumBankAccountTypeBusinessChecking: "Business Checking",
  bankruptcy: "Bankruptcy",
  activeDispute: "Active Dispute",
  disputeThisDebt: "Dispute This Debt",
  areYouSureYouWantToVoidThePayment: "Are you sure you want to void this payment?",
  areYouSureYouWantToRefundThePayment: "Are you sure you want to refund this payment?",
  areYouSureAbstractCommunication: "Are you sure you want to proceed?",
  enumPoliceRulesoutsideValidCommunicationTimes: "Communication outside business hours",
  enumPoliceRulesNotABusinessDay: "Communication date not a business day",
  enumPoliceRulesUserCommunicationPreferences: "Communication method deselected",
  enumPoliceRulesAllowToCommunicateWithUser: "User communication frozen",
  enumPoliceRulesNotInValidationPeriod: "User validation not received",
  enumPoliceRulesCheckMaxContacts: "User contacted in the last week",
  enumPoliceRulesCheckMaxContactsAttemptsInAWeek: "Over 7 in 7 communications",
  enumPoliceRulesCheckMaxContactsAttemptsInADay: "Date contains too many communication attempts",
  enumPoliceRulesPhoneNotReassigned: "Phone number invalid",
  enumPoliceRulesCheckPhoneValidity: "Phone number invalid",
  enumPoliceRulesNoEmailToNy: "Not allowed to email residents in New York",
  enumPoliceRulesNotFromUnallowedStates: "Not allowed to communicate with user's location",
  enumPoliceRulesAccountNotPurchased: "ACCOUNT NOT OWNED BY BOUNCE",
  filterByPrincipal: "Filter by principal",
  deleteReport: "Delete report",

  //Payment plan
  frequency: "Frequency",
  monthly: "Monthly",
  biWeekly: "Bi-Weekly",
  weekly: "Weekly",
  firstAndFifteenth: "1st & 15th",
  manage: "Manage",
  resolve: "Resolve",
  paymentsOf: " payments of ",
  paymentOf: " payment of ",
  lastPaymentOf: "last payment of ",
  paymentOn: "Payment on ",
  PlanOptions: "Plan options",
  presetPlan: "Build plan",
  customPaymentV2: "custom payment",
  congratulations: "Congratulations!",
  paymentSubmitted: "Payment Submitted",
  underTheLimit: "(under the limit)",
  exceededTheLimit: "(exceeds the limit)",
  remainderWillBeAdded: "(A remainder of under 10$ will be added to the plan's last installment)",
  thisAccountHasNoFiles: "This account has no files",
  chatWithUs: " chat with us",
  toFindTheRightSolution: "  to find the right solution for you.",
  selectDateOfBirth: "Select date of birth",
  nonLinear: "Non linear",
  preparingYourOptions: "Preparing your options...",
  hardshipIntro: "Hardship Intro",
  hardshipPlans: "Hardship Plans",
  whatIfINeedToAdjustItLater: "What if I need to adjust it later?",
  wereJustAPhoneCallOrChatAway:
    "We're just a phone call or chat away. Just let us know how we can help (please provide a 3-business-day notice).",
  youCanAlwaysResolveThisDebt: "You can always resolve this debt with a one time payment at any time.",

  //digest
  dateOfBirth: "Date of birth",
  address: "Address",
  discount: "Discount",

  // Account
  accounts: "Accounts",
  from: "From",
  resolveNowForAsLittleAs: "Resolve now for as little as ",
  resolveNowFor: "Resolve now for ",
  paidTemporaryPlan: " paid (Temporary plan)",
  totalBalancePaid: "Total balance paid: ",
  represented: "Represented",
  activePlan: "Active plan",
  unpaid: "Unpaid",
  accountResolved: "Account resolved",
  temporaryPlan: "Temporary plan",
  paymentIssue: "Payment issue",
  paidOutFrom: " paid out of ",
  nextDueDate: "Next due date: ",
  lateInstallmentAmount: "Late installment amount: ",
  wasDueOn: "Was due on ",
  negativeEntryOnCreditReport: "A negative entry was made on your credit report",
  onceYourPaymentPlanCompleted:
    "Once your payment plan is completed and account is resolved, we will notify the credit bureaus to remove the listing of this debt that Bounce AI, Inc has reported.",
  creditReportListingIn: "Credit report listing in {days_str}",
  creditReportListingToday: "Credit report listing today",
  resolveDebtToPreventCollectionsListing: "Resolve this debt to prevent a collections listing on your credit report.",
  importantNotice: "Important notice",
  yourDebtIsInDispute: "Your debt is in dispute",
  yourDisputeSuccessfullyFiled:
    "Your dispute was successfully filed and is under investigation. We'll update you soon. If you have any questions or concerns, contact us or call at (888) 482-5060.",

  // Dispute v2
  debtWasPreviouslyPaid: "Debt was previously paid",
  thisDebtHasAlreadyBeenPaid: "This debt has already been paid and I have receipts or bank statements to prove it.",
  incorrectDebtDetails: "Incorrect debt details",
  thereIsAnErrorWithTheAmount:
    "There is an error with the amount or other information about this debt and I have documents to prove it.",
  iWouldLikeToRequestVerification: "I would like to request verification of this debt",
  identifyTheftOrFraud: "Identity theft or fraud",
  thisAccountWasOpenedFraudulently:
    "This account was opened and/or used fraudulently without my permission and I have filed a FTC fraud report and police report.",
  exit: "Exit",
  multiAccount: "Multi account",

  //Dispute step 4 options
  continueWithTheDispute: "Continue with the dispute",
  solidCaseToShare: "I have a solid case to share",
  chatWithUsOnline: "Chat with us online or give us a call",
  viewMyPaymentOptions: "View my payment options",
  findOtherAvailableResolutions: "Find other available resolutions",
  fileFraudClaim: "File a fraud claim",
  provideFraudDocumentation: "Provide fraud documentation",
  or: "Or",
  home: "home",

  // Backoffice
  pricing: "Pricing",
  washing: "Washing",
  importPricing: "Import Pricing",
  importUsers: "Import Users",
  importPayments: "Import Payments",
  mediaUpload: "Media Upload",
  generatePricing: "Generate Pricing",
  reportType: "Report Type",
  fileName: "File Name",
  dsc: "DSC",
  batch: "Batch",
  dscPanel: "DSC Panel",
  conversations: "Conversations",
  add: "Add",
  addedToRepresentationCompaniesSuccessfully: `Added "{name}" to representation companies successfully`,
  failedToAddToRepresentationCompanies: `Failed to add "{name}" to representation companies`,
  yourRequestBeingProceed: "Your request is being proceed",
  theFileIsntReadyYet: "The file isn't ready yet",
  theFileNotFound: "The file was not found",
  messageWillBeSent: "A slack message will be sent to #spring-notifications upon completion.",
  fileIdToDownload: "The file id to download is:",
  jobIdToTrack: "The job id to track is:",
  attachFiles: "Attach files",
  phones: "Phones",
  responseIsScheduledSuccessfully: "Response is scheduled or sent successfully",
  expiredLinkErrorExplanation:
    "To continue, you can either log into your account and click" +
    ' on "Switch to Autopay" under the menu, or <link>chat with an expert</link> to get assistance.',
};
